'use client';

import { useEffect } from 'react';
import { initErrorTracking } from '@focal-point/error-tracking/client';

export function ErrorTrackingProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    const accessToken = process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN;
    const environment =
      process.env.NEXT_PUBLIC_VERCEL_ENV ||
      process.env.NODE_ENV ||
      'development';
    const version = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || undefined;

    if (!accessToken) {
      // No announcement log here: the console provider this initializes writes
      // every captured event to the console already, so the fallback is
      // self-evident the first time anything is tracked.
      initErrorTracking({
        projectId: 'default',
        provider: 'console',
        serviceName: 'FocalPointSolutions',
        environment,
        version,
      });
      return;
    }

    initErrorTracking({
      projectId: accessToken,
      provider: 'rollbar',
      serviceName: 'FocalPointSolutions',
      environment,
      version,
    });
  }, []);

  return <>{children}</>;
}
